// extracted by mini-css-extract-plugin
export var orderSummary = "_sd-0";
export var showMoreLessButton = "_sd-1";